import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  rowChecked: {
    borderRadius: 8,
    cursor: 'pointer',
    backgroundColor: '#ececec',
    '& #kebab': {
      color: '#263057'
    }
  },
  row: {
    borderRadius: 8,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#ececec',
      '& #kebab': {
        color: '#263057'
      }
    }
  },
  itemCheck: {
    height: 44,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    color: '#263057',
    width: '3rem',
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
    textAlign: 'center'
  },
  itemName: {
    height: 44,
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 'regular',
    color: '#2C3532',
    textAlign: 'start',
    '&:hover': {
      backgroundColor: '#ececec'
    }
  },
  itemAbsolutePath: {
    height: 44,
    '&:hover': {
      backgroundColor: '#ececec'
    },
    '@media all and (max-width: 1000px)': {
      display: 'none'
    }
  },
  pathText: {
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 'regular',
    color: '#2C3532',
    textAlign: 'start'
  },
  pathTextName: {
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 'regular',
    color: '#2C3532',
    textAlign: 'start',
    textOverflow: 'ellipsis',
    width: 200,
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  },
  itemPurgeDate: {
    height: 44,
    fontFamily: 'Roboto',
    fontWeight: 'regular',
    fontSize: 14,
    color: '#2C3532',
    textAlign: 'start',
    '&:hover': {
      backgroundColor: '#ececec'
    },
    '@media all and (max-width: 1200px)': {
      display: 'none'
    }
  },
  itemPurgeActionUser: {
    height: 44,
    fontFamily: 'Roboto',
    fontWeight: 'regular',
    fontSize: 14,
    color: '#263057',
    textAlign: 'start',
    '@media all and (max-width: 450px)': {
      display: 'none'
    }
  },

  itemKebab: {
    height: 44,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    color: '#2C3532',
    width: '2rem',
    textAlign: 'start',
    borderTopRightRadius: 8,
    borderBottomRightRadius: 8,
    '&:hover': {
      backgroundColor: '#ececec'
    }
  },
  kebab: {
    color: '#B3B3B3'
  },
  itemArchive: {
    height: 44,
    fontFamily: 'Roboto',
    fontWeight: 'regular',
    fontSize: 14,
    color: '#2C3532',
    textAlign: 'start',
    '@media all and (max-width: 900px)': {
      display: 'none'
    }
  },
  itemDelete: {
    height: 44,
    fontFamily: 'Roboto',
    fontWeight: 'regular',
    fontSize: 14,
    color: '#263057',
    textAlign: 'start',
    '@media all and (max-width: 900px)': {
      display: 'none'
    }
  },

  itemUser: {
    height: 44,
    fontFamily: 'Roboto',
    fontWeight: 'regular',
    fontSize: 14,
    color: '#263057',
    textAlign: 'start',
    '@media all and (max-width: 900px)': {
      display: 'none'
    }
  },
  headLastuse: {
    height: 44,
    fontFamily: 'Roboto',
    fontWeight: 'regular',
    fontSize: 14,
    color: '#263057',
    textAlign: 'start',
    '@media all and (max-width: 900px)': {
      display: 'none'
    }
  },
  headClient: {
    height: 44,
    fontFamily: 'Roboto',
    fontWeight: 'regular',
    fontSize: 14,
    color: '#263057',
    textAlign: 'start',
    '@media all and (max-width: 900px)': {
      display: 'none'
    }
  }
}))

export default useStyles
